import Menu1 from "../../assets/Dashboard/menu-1.svg";
import Menu2 from "../../assets/Dashboard/menu-2.svg";
import Menu3 from "../../assets/Dashboard/menu-3.svg";
import Menu4 from "../../assets/Dashboard/menu-4.svg";
import Menu5 from "../../assets/Dashboard/menu-5.svg";
import Menu6 from "../../assets/Dashboard/menu-6.svg";
export const MenuItems = [
  {
    id: 1,
    img: Menu1,
    name: "Stir Fry Pasta",
    price: 2500,
    amount: 1,
  },
  {
    id: 2,
    img: Menu2,
    name: "Stir Fry Pasta2",
    price: 1500,
    amount: 1,
  },
  {
    id: 3,
    img: Menu3,
    name: "Stir Fry Pasta3",
    price: 1500,
    amount: 1,
  },
  {
    id: 4,
    img: Menu4,
    name: "BlueBerry Pancake",
    price: 1500,
    amount: 1,
  },
  {
    id: 5,
    img: Menu5,
    name: "BlueBerry Pancake2",
    price: 1500,
    amount: 1,
  },
  {
    id: 6,
    img: Menu6,
    name: "Stir Fry Pasta4",
    price: 1500,
    amount: 1,
  },

  {
    id: 7,
    img: Menu6,
    name: "Stir Fry Pasta4",
    price: 1500,
    amount: 1,
  },

  {
    id: 8,
    img: Menu6,
    name: "Stir Fry Pasta4",
    price: 1500,
    amount: 1,
  },

  {
    id: 9,
    img: Menu6,
    name: "Stir Fry Pasta4",
    price: 1500,
    amount: 1,
  },
];
